"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutWidget = void 0;
var react_1 = __importStar(require("react"));
var editorStyles = __importStar(require("./LayoutWidget.css"));
var publicStyles = __importStar(require("@CommonFrontend/Public/Widgets/Layout/Layout.css"));
var classnames_1 = __importDefault(require("classnames"));
var dynamic_1 = require("@vanilla-extract/dynamic");
var SelectionRing_1 = require("Project/QwilrEditor/RegistryElement/SelectionRing");
var useSelectionState_1 = require("Project/QwilrEditor/RegistryElement/useSelectionState");
var LayoutContext_1 = require("./LayoutContext");
var tiny_invariant_1 = __importDefault(require("tiny-invariant"));
var inversify_react_1 = require("inversify-react");
var WidgetManager_1 = require("Project/QwilrEditor/WidgetManager");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var LayoutWidget = function (_a) {
    var _b;
    var attributes = _a.attributes, element = _a.element, children = _a.children;
    var selectionRingContext = (0, SelectionRing_1.useSelectionRingContext)();
    var widgetSelectionState = (0, useSelectionState_1.useSelectionState)(element).widgetSelectionState;
    var editMode = (0, LayoutContext_1.useLayoutContext)().editMode;
    var widgetManager = (0, inversify_react_1.useInjection)(WidgetManager_1.WidgetManager);
    var selected = ["multi", "circle"].includes(widgetSelectionState);
    var layoutRef = (0, react_1.useRef)(null);
    var gap = 12;
    var _c = __read((0, react_1.useState)([]), 2), openColumnMenu = _c[0], setOpenColumnMenu = _c[1];
    var _d = __read((0, react_1.useState)(null), 2), resizingState = _d[0], setResizingState = _d[1];
    var resizingStateRef = (0, react_1.useRef)(null);
    var resizingGapIndex = (_b = resizingState === null || resizingState === void 0 ? void 0 : resizingState.gapIndex) !== null && _b !== void 0 ? _b : null;
    (0, react_1.useEffect)(function () {
        resizingStateRef.current = resizingState;
    }, [resizingState]);
    (0, react_1.useEffect)(function () {
        if (resizingGapIndex === null || layoutRef.current === null) {
            return;
        }
        var _a = layoutRef.current.getBoundingClientRect(), left = _a.left, width = _a.width;
        var columnWidth = (width - 23 * gap) / 24;
        var startingNotch = element.data.columns.reduce(function (total, column, idx) { return (idx <= resizingGapIndex ? total + column.width : total); }, 0);
        var startingNotchX = left + startingNotch * columnWidth + (startingNotch - 1) * gap + gap / 2;
        var mouseMoveListener = function (event) {
            var _a, _b;
            var fractionalDistance = (event.x - startingNotchX) / (columnWidth + gap);
            var attemptedNotchDistance = fractionalDistance < 0 ? Math.round(Math.abs(fractionalDistance)) * -1 : Math.round(fractionalDistance);
            var currentLeftColumnWidth = (_a = element.data.columns[resizingGapIndex]) === null || _a === void 0 ? void 0 : _a.width;
            var currentRightColumnWidth = (_b = element.data.columns[resizingGapIndex + 1]) === null || _b === void 0 ? void 0 : _b.width;
            (0, tiny_invariant_1.default)(currentLeftColumnWidth != null, "left column has no current width");
            (0, tiny_invariant_1.default)(currentRightColumnWidth != null, "right column has no current width");
            var distance = attemptedNotchDistance < 0
                ? Math.min(Math.abs(attemptedNotchDistance), currentLeftColumnWidth - 1) * -1
                : Math.min(attemptedNotchDistance, currentRightColumnWidth - 1);
            setResizingState({ gapIndex: resizingGapIndex, distance: distance });
        };
        var mouseUpListener = function () {
            setResizingState(null);
            if (resizingStateRef.current) {
                widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("layout", {
                    action: "resizeColumn",
                    path: widgetManager.getPath(element),
                    columnIndex: resizingStateRef.current.gapIndex,
                    distance: resizingStateRef.current.distance,
                }));
            }
        };
        document.addEventListener("mousemove", mouseMoveListener);
        document.addEventListener("mouseup", mouseUpListener);
        return function () {
            document.removeEventListener("mousemove", mouseMoveListener);
            document.removeEventListener("mouseup", mouseUpListener);
        };
    }, [resizingGapIndex, element.data.columns, element, widgetManager]);
    return (react_1.default.createElement("div", __assign({}, attributes, { ref: layoutRef, className: (0, classnames_1.default)(attributes.className, publicStyles.layout, editorStyles.layout({ mouseOverSelectableRegion: selectionRingContext.mouseOverSelectableRegion, selected: selected })) }), react_1.default.Children.map(children, function (child, idx) {
        var _a;
        var columnData = element.data.columns[idx];
        (0, tiny_invariant_1.default)(!!columnData, "no column data for column index ".concat(idx));
        var width = columnData.width;
        if (!!resizingState) {
            if (idx === resizingState.gapIndex) {
                width += resizingState.distance;
            }
            else if (idx === resizingState.gapIndex + 1) {
                width -= resizingState === null || resizingState === void 0 ? void 0 : resizingState.distance;
            }
        }
        var columnMenu = {
            isOpen: openColumnMenu.includes(idx),
            open: function () {
                setOpenColumnMenu(__spreadArray(__spreadArray([], __read(openColumnMenu), false), [idx], false));
            },
            close: function () {
                setOpenColumnMenu(openColumnMenu.filter(function (c) { return c !== idx; }));
            },
            toggle: function () {
                if (openColumnMenu.includes(idx)) {
                    setOpenColumnMenu(openColumnMenu.filter(function (c) { return c !== idx; }));
                }
                else {
                    setOpenColumnMenu(__spreadArray(__spreadArray([], __read(openColumnMenu), false), [idx], false));
                }
            },
        };
        return (react_1.default.createElement("div", { style: (0, dynamic_1.assignInlineVars)((_a = {},
                _a[publicStyles.columnWidth] = width.toString(),
                _a)), className: (0, classnames_1.default)(publicStyles.layoutColumn, editorStyles.layoutColumn) },
            idx < element.data.columns.length - 1 && (react_1.default.createElement("div", __assign({ contentEditable: false, className: editorStyles.gap({ editMode: editMode, resizing: (resizingState === null || resizingState === void 0 ? void 0 : resizingState.gapIndex) === idx }) }, (editMode
                ? {
                    onMouseDown: function (e) {
                        e.stopPropagation();
                        setResizingState({ gapIndex: idx, distance: 0 });
                    },
                }
                : {})))),
            react_1.default.createElement("div", { className: editorStyles.layoutColumnContent({ editMode: editMode }) }, child),
            react_1.default.createElement("div", { className: editorStyles.columnFrame({
                    mouseOverWidget: selectionRingContext.mouseOverWidget,
                    selected: selected,
                    editMode: editMode,
                    isResizing: !!resizingState,
                }) },
                react_1.default.createElement("div", { contentEditable: false },
                    react_1.default.createElement(kaleidoscope_1.OptionMenu, { isOpen: columnMenu.isOpen, onClose: columnMenu.close, button: react_1.default.createElement(kaleidoscope_1.IconButton, { className: editorStyles.columnToolbarButton({
                                editMode: editMode,
                                isOpen: columnMenu.isOpen,
                                isResizing: !!resizingState,
                            }), icon: react_1.default.createElement(icons_1.DragHandle, { className: editorStyles.columnToolbarButtonIcon }), onClick: columnMenu.toggle }) },
                        react_1.default.createElement(kaleidoscope_1.OptionMenuItem, null, "Placeholder"))))));
    })));
};
exports.LayoutWidget = LayoutWidget;
